import { render, staticRenderFns } from "./returnSubmitOrder.vue?vue&type=template&id=7df5d073&scoped=true"
import script from "./returnSubmitOrder.vue?vue&type=script&lang=js"
export * from "./returnSubmitOrder.vue?vue&type=script&lang=js"
import style0 from "./returnSubmitOrder.vue?vue&type=style&index=0&id=7df5d073&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df5d073",
  null
  
)

export default component.exports